import(/* webpackMode: "eager" */ "/vercel/path1/app/history/page.tsx");
